<script setup lang="ts">
import type { SupportedErrors } from "effect-app/client/errors"
import * as Cause from "effect/Cause"
import * as Match from "effect/Match"

defineProps<{ cause: Cause.Cause<unknown> }>()
const config = useRuntimeConfig()

const formatError = (cause: Cause.Cause<unknown>): string => {
  if (Cause.hasInterruptsOnly(cause)) {
    return "Die Anfrage wurde unterbrochen"
  }
  const error = Cause.squash(cause) as SupportedErrors
  return Match.value(error).pipe(
    Match.tags({
      NotFoundError: () => "Nicht gefunden",
      NotLoggedInError: () => "Sie mussen eingelogt sein",
      UnauthorizedError: () => "Sie sind nicht berechtigt, diese Aktion auszuführen"
    }),
    Match.orElse(
      () =>
        "Es ist ein Fehler aufgetreten. Wir wurden benachrichtigt und werden das Problem in Kürze beheben. Versuchen Sie es erneut."
    )
  )
}
</script>

<template>
  <div>
    {{ formatError(cause) }}
    <pre v-if="config.public.env !== 'prod'">
      dev details: {{ Cause.pretty(cause) }}
    </pre>
  </div>
</template>
